<template>
  <div class="relative h-screen w-full bg-white flex items-center justify-center">
    <auth-logo-banner class="absolute top-0 w-full" />

    <div class="w-full vx-row no-gutter justify-center">
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
        <vx-card
          :title="$t('NotificationPreferences')">
          <form @submit.prevent>
            <div class="mb-3 flex items-center">
              <vs-checkbox
                v-model="specialOffers"
                class="inline-flex mt-0">
              </vs-checkbox>
              <span>
                {{ $t('SpecialOffers') }}
              </span>
            </div>

            <div class="mb-3 flex items-center">
              <vs-checkbox
                v-model="newFeaturesAvailable"
                class="inline-flex mt-0">
              </vs-checkbox>
              <span>
                {{ $t('NewFeaturesAvailable') }}
              </span>
            </div>

            <div class="flex items-center justify-start mt-base">
              <vs-button
                class="w-full md:w-auto"
                @click="updateFlagsNotification">
                {{ $t('$General.Update') }}
              </vs-button>
            </div>
          </form>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import AuthLogoBanner from '@/views/pages/auth/components/AuthLogoBanner.vue';

import userService from '@/api/modules/user.service';

/**
 *
 * @module views/modules/user-account/UserAccountProfileNotificationPreferences.vue
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 */

export default {
  name: 'UserAccountDetailsBasicInformationNotificationPreferences',
  i18n: {
    messages: {
      en: {
        SpecialOffers: 'Special offers',
        NewFeaturesAvailable: 'New features available',
        NotificationPreferences: 'Notification preferences',
        UpdateNotificationPreferencesInfTitle: 'Notification preferences update',
        UpdateNotificationPreferencesMsg: 'Notification preferences updated successfully',
      },
    },
  },
  components: {
    AuthLogoBanner,
  },
  data() {
    return {
      uuid: '',
      specialOffers: false,
      newFeaturesAvailable: false,
    };
  },
  created() {
    this.uuid = this.$route.params.uuid;

    this.loadPreferenceNotifications();
  },
  methods: {
    async loadPreferenceNotifications() {
      this.$vs.loading({ type: 'radius' });

      try {
        const response = await userService.getNotificationPreferences(this.uuid);
        const { specialOffers, newFeaturesAvailable } = response.data;

        this.specialOffers = specialOffers;
        this.newFeaturesAvailable = newFeaturesAvailable;
      } catch (error) {
        this.$router.push({ name: 'not-authorized' }).catch(() => {});
      } finally {
        this.$vs.loading.close();
      }
    },
    async updateFlagsNotification() {
      this.$vs.loading({ type: 'radius' });
      await userService.updateNotificationPreferences(this.uuid, {
        specialOffers: this.specialOffers,
        newFeaturesAvailable: this.newFeaturesAvailable,
      });
      this.$vs.loading.close();

      this.$showSuccessActionNotification({
        title: this.$t('UpdateNotificationPreferencesInfTitle'),
        text: this.$t('UpdateNotificationPreferencesMsg'),
      });
    },
  },
};

</script>
